import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-[#E8E6E1] bg-[#F2EFEB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.png" alt="Per manina" className="w-8 h-8 rounded-full object-cover" />
            <span className="font-display text-xl font-semibold text-[#1A362D]">Per manina</span>
          </div>
          <p className="font-ui text-sm text-[#5C6B64] leading-relaxed max-w-sm">
            Una community di genitori che si aiutano nelle scelte importanti: scuole dell'infanzia, libri e giochi educativi per i primi anni.
          </p>
          <a
            href="https://www.instagram.com/permanina"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            aria-label="Seguici su Instagram"
            className="mt-5 inline-flex items-center gap-2 text-sm font-ui font-medium text-[#1A362D] hover:text-[#C05C45] transition-colors group"
          >
            <span className="w-9 h-9 rounded-full bg-white border border-[#E8E6E1] group-hover:border-[#C05C45] group-hover:bg-[#C05C45] flex items-center justify-center transition-colors">
              <Instagram size={17} className="text-[#1A362D] group-hover:text-white transition-colors" />
            </span>
            Seguici su Instagram
          </a>
        </div>
        <div>
          <p className="label-eyebrow mb-3">Esplora</p>
          <ul className="space-y-2 font-ui text-sm">
            <li><Link to="/cerca" data-testid="footer-cerca-link" className="text-[#1A362D] hover:text-[#C05C45]">Cerca scuole</Link></li>
            <li><Link to="/migliori" data-testid="footer-migliori-link" className="text-[#1A362D] hover:text-[#C05C45]">Migliori per città</Link></li>
            <li><Link to="/prodotti" data-testid="footer-products-link" className="text-[#1A362D] hover:text-[#C05C45]">Libri & Giochi</Link></li>
            <li><Link to="/suggerisci" data-testid="footer-suggerisci-link" className="text-[#1A362D] hover:text-[#C05C45]">Aggiungi una scuola</Link></li>
            <li><Link to="/suggerisci-prodotto" data-testid="footer-suggerisci-prod-link" className="text-[#1A362D] hover:text-[#C05C45]">Consiglia materiale educativo</Link></li>
            <li><Link to="/area-personale" data-testid="footer-area-link" className="text-[#1A362D] hover:text-[#C05C45]">Area personale</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-eyebrow mb-3">Informazioni</p>
          <ul className="space-y-2 font-ui text-sm">
            <li><Link to="/info/privacy" data-testid="footer-privacy-link" className="text-[#1A362D] hover:text-[#C05C45]">Privacy Policy</Link></li>
            <li><Link to="/info/termini" data-testid="footer-terms-link" className="text-[#1A362D] hover:text-[#C05C45]">Termini di Servizio</Link></li>
            <li><Link to="/info/disclaimer" data-testid="footer-disclaimer-link" className="text-[#1A362D] hover:text-[#C05C45]">Disclaimer legale</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E8E6E1]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-[11px] text-[#8A9691] font-ui leading-relaxed">
          <p data-testid="footer-amazon-disclaimer">
            <strong className="text-[#5C6B64]">Disclosure affiliati:</strong> Per manina partecipa al Programma
            Affiliazione Amazon EU, un programma di affiliazione che consente ai siti di percepire una commissione
            pubblicitaria pubblicizzando e fornendo link al sito Amazon.it. In quanto Affiliato Amazon, riceviamo un
            guadagno dagli acquisti idonei. Le commissioni non comportano alcun costo aggiuntivo per chi acquista e
            non influenzano in alcun modo le esperienze o l'ordinamento dei contenuti.
          </p>
        </div>
      </div>
      <div className="border-t border-[#E8E6E1]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-[#8A9691] font-ui flex flex-col sm:flex-row gap-2 sm:justify-between">
          <span>© {new Date().getFullYear()} Per manina — Tutti i diritti riservati</span>
          <span>Realizzato con cura in Italia</span>
        </div>
      </div>
    </footer>
  );
}
